import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import config from "../../config";
import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [createPersistedState({
    paths: ['today', 'placeorder', 'shopCart', 'shopCartPrefill'],
    storage: window.localStorage,
  })],
  state: {
    lazy: true,
    doctor: {},
    currentservice: 0,
    currenttoday: 0,
    currenttodaynumber: 0,
    currenttodaycalling: 0,
    currenttodaynocalling: 0,
    currentnextdays: 0,
    currentrecipe: 0,
    currentresults: 0,
    currentenquiry: 0,
    currentshop: 0,
    today: {},
    nextdays: {},
    recipe: {},
    torecipe: {},
    results: {},
    toresults: {},
    enquiry: {},
    placeorder: {},
    type: "",
    service: null,
    error: "",
    orderstatus: {},
    name: "",
    maxheight: false,
    isTimeRequest: false,
    shopMenu: 0,
    shopCategory: 0,
    shopCategoryParent: 0,
    shopCart: {},
    shopCartPrefill: false,
    shopOrder: null,
  },
  mutations: {
    setDoctor(state, data) {
      state.doctor = data;
    },
    setLazy(state, data) {
      state.lazy = data;
    },
    setCurrentService(state, data) {
      state.currentservice = data;
    },
    setCurrentToday(state, data) {
      state.currenttoday = data;
    },
    setCurrentTodayNumber(state, data) {
      state.currenttodaynumber = data;
    },
    setCurrentTodayCalling(state, data) {
      state.currenttodaycalling = data;
    },
    setCurrentTodayNoCalling(state, data) {
      state.currenttodaynocalling = data;
    },
    setCurrentNextDays(state, data) {
      state.currentnextdays = data;
    },
    setCurrentRecipe(state, data) {
      state.currentrecipe = data;
    },
    setCurrentResults(state, data) {
      state.currentresults = data;
    },
    setCurrentEnquiry(state, data) {
      state.currentenquiry = data;
    },
    setCurrentShop(state, data) {
      state.currentshop = data;
    },
    setToday(state, data) {
      state.today = data;
    },
    setNextDays(state, data) {
      state.nextdays = data;
    },
    setRecipe(state, data) {
      state.recipe = data;
    },
    setToRecipe(state, data) {
      state.torecipe = data;
    },
    setResults(state, data) {
      state.results = data;
    },
    setToResults(state, data) {
      state.toresults = data;
    },
    setEnquiry(state, data) {
      state.enquiry = data;
    },
    setPlaceOrder(state, data) {
      state.placeorder = data;
    },
    setType(state, data) {
      state.type = data;
    },
    setService(state, data) {
      state.service = data;
    },
    setError(state, data) {
      state.error = data;
    },
    setOrderStatus(state, data) {
      state.orderstatus = data;
    },
    setName(state, data) {
      state.name = data;
    },
    setMaxHeight(state, data) {
      state.maxheight = data;
    },
    setTimeRequest(state, data) {
      state.isTimeRequest = data;
    },
    setShopMenu(state, data) {
      state.shopMenu = data;
    },
    setShopCategory(state, data) {
      state.shopCategory = data;
    },
    setShopCategoryParent(state, data) {
      state.shopCategoryParent = data;
    },
    setShopCart(state, data) {
      state.shopCart = data;
    },
    setShopCartPrefill(state, data) {
      state.shopCartPrefill = data;
    },
    setShopOrder(state, data) {
      state.shopOrder = data;
    },
  },
  getters: {
    doctor: state => {
      return state.doctor;
    },
    lazy: state => {
      return state.lazy;
    },
    currentService: state => {
      return state.currentservice;
    },
    currentToday: state => {
      return state.currenttoday;
    },
    currentTodayNumber: state => {
      return state.currenttodaynumber;
    },
    currentTodayCalling: state => {
      return state.currenttodaycalling;
    },
    currentTodayNoCalling: state => {
      return state.currenttodaynocalling;
    },
    currentNextDays: state => {
      return state.currentnextdays;
    },
    currentRecipe: state => {
      return state.currentrecipe;
    },
    currentResults: state => {
      return state.currentresults;
    },
    currentEnquiry: state => {
      return state.currentenquiry;
    },
    currentShop: state => {
      return state.currentshop;
    },
    today: state => {
      return state.today;
    },
    nextDays: state => {
      return state.nextdays;
    },
    recipe: state => {
      return state.recipe;
    },
    torecipe: state => {
      return state.torecipe;
    },
    results: state => {
      return state.results;
    },
    toresults: state => {
      return state.toresults;
    },
    enquiry: state => {
      return state.enquiry;
    },
    placeOrder: state => {
      return state.placeorder;
    },
    type: state => {
      return state.type;
    },
    service: state => {
      return state.service;
    },
    error: state => {
      return state.error;
    },
    orderStatus: state => {
      return state.orderstatus;
    },
    name: state => {
      return state.name;
    },
    maxHeight: state => {
      return state.maxheight;
    },
    isTimeRequest: state => {
      return state.isTimeRequest;
    },
    shopMenu: state => {
      return state.shopMenu;
    },
    shopCategory: state => {
      return state.shopCategory;
    },
    shopCategoryParent: state => {
      return state.shopCategoryParent;
    },
    shopCart: state => {
      return state.shopCart;
    },
    shopCartPrefill: state => {
      return state.shopCartPrefill;
    },
    shopOrder: state => {
      return state.shopOrder;
    }
  },
  actions: {
    setCurrentService: ({ commit }, data) => {
      commit("setCurrentService", data);
    },
    setCurrentToday: ({ commit }, data) => {
      commit("setCurrentToday", data);
    },
    setCurrentTodayNumber: ({ commit }, data) => {
      commit("setCurrentTodayNumber", data);
    },
    setCurrentTodayCalling: ({ commit }, data) => {
      commit("setCurrentTodayCalling", data);
    },
    setCurrentTodayNoCalling: ({ commit }, data) => {
      commit("setCurrentTodayNoCalling", data);
    },
    setCurrentNextDays: ({ commit }, data) => {
      commit("setCurrentNextDays", data);
    },
    setCurrentRecipe: ({ commit }, data) => {
      commit("setCurrentRecipe", data);
    },
    setCurrentResults: ({ commit }, data) => {
      commit("setCurrentResults", data);
    },
    setCurrentEnquiry: ({ commit }, data) => {
      commit("setCurrentEnquiry", data);
    },
    setCurrentShop: ({ commit }, data) => {
      commit("setCurrentShop", data);
    },
    setServiceNextDays: ({ commit }, data) => {
      commit("setService", data);
    },
    setDoctor: ({ commit }, data) => {
      commit("setDoctor", data);
    },
    setToday: ({ commit }, data) => {
      commit("setToday", data);
    },
    setNextDays: ({ commit }, data) => {
      commit("setNextDays", data);
    },
    setTimeRequest: ({ commit }, data) => {
      commit("setTimeRequest", data);
    },
    setShopMenu: ({ commit }, data) => {
      commit("setShopMenu", data);
    },
    setShopCategory: ({ commit }, data) => {
      commit("setShopCategory", data);
    },
    setShopCategoryParent: ({ commit }, data) => {
      commit("setShopCategoryParent", data);
    },
    setShopCart: ({commit}, data) => {
      commit("setShopCart", data);
    },
    addToShopCart: ({ commit, state }, data) => {
      // console.warn(commit, state, data);

      let duplicate = false;

      if (!state.shopCart[data.doctor]) {
        state.shopCart[data.doctor] = [];
      }

      if (state.shopCart[data.doctor].length > 0) {
        state.shopCart[data.doctor].forEach((item, index) => {
          // console.warn(item, data);

          if (item.id === data.product.id) {
            duplicate = true;

            state.shopCart[data.doctor][index].count = (item.count + 1);
            commit("setShopCart", state.shopCart);

          } else if (!duplicate && (index + 1) === state.shopCart[data.doctor].length) {
            data.product['count'] = 1;

            state.shopCart[data.doctor].push(data.product);
            commit("setShopCart", state.shopCart);
          }
        })
      } else {
        data.product['count'] = 1;

        state.shopCart[data.doctor].push(data.product);
        commit("setShopCart", state.shopCart);
      }
    },
    setShopCartPrefill: ({commit}, data) => {
      commit("setShopCartPrefill", data);
    },
    setShopOrder: ({ commit }, data) => {
      commit("setShopOrder", data);
    },
    getRecipe: ({ commit, state }) => {
      axios.get(config.API + "/recipe/" + state.name).then(response => {
        commit("setRecipe", response.data);
      });
    },
    getResults: ({ commit, state }) => {
      axios.get(config.API + "/result/" + state.name).then(response => {
        commit("setResults", response.data);
      });
    },
    placeOrder: ({ commit, state }, data) => {
      // console.warn(data);
      const type = data.type;
      const service = data.infoservice;
      const torecipe = {
        name: data.name,
        inr: data.pnr,
        medicine: data.medicine
      };
      const toresults = {
        name: data.name,
        inr: data.pnr
      };
      axios
        .post(config.API + "/placeorder/" + state.name, JSON.stringify(data))
        .then(response => {
          commit("setPlaceOrder", response.data);
          commit("setType", type);
          commit("setService", service);
          if (type == "recipe") {
            commit("setToRecipe", torecipe);
          }
          if (type == "result") {
            commit("setToResults", toresults);
          }

          // if (type == "enquiry") {
          //   let logger = Vue.prototype.$raven;
          //   logger.captureBreadcrumb({category: "enquiry", data: [data, response], level: 'warning'});
          //   logger.captureException('Enquiry send');
          // }
        });
    },
    postToday({ commit, state }) {
      axios
        .post(
          config.API + "/today/" + state.name,
          JSON.stringify({
            order_id: state.placeorder.order_id,
            order_key: state.placeorder.order_key
          })
        )
        .then(response => {
          commit("setToday", response.data);
        });
    },
    getOrderStatus: ({ commit, state }) => {
      axios
        .post(
          config.API + "/orderstatus/" + state.name,
          JSON.stringify({
            order_id: state.placeorder.order_id,
            order_key: state.placeorder.order_key
          })
        )
        .then(response => {
          commit("setOrderStatus", response.data);
        });
    },
    checkBack: () => {
      let back = document.getElementById("btn-back");
      if (typeof back != "undefined" && back != null) {
        window.history.pushState(null, "", window.location.href);
        window.onpopstate = function() {
          back.click();
          window.history.pushState(null, "", window.location.href);
        };
      } else {
        window.onpopstate = function() {
          window.location.href = config.URLHOME;
        };
      }
    }
  }
});
